import React from 'react';
import styled from 'styled-components';
import { Route, NavLink } from 'react-router-dom';

import tokens from '@spotify-internal/encore-foundation';
import { useMe } from '../../../hooks/useMe';
import { TermsAndConditions } from '../../TermsAndConditions';
import { Footer } from './Footer';
import { Header } from './Header';
import { Flyout } from './Flyout';

type Props = {
  navItems: { to: string; children: string }[];
  banner: React.ReactNode;
  content: React.ReactNode;
};

export function Layout(props: Props) {
  const me = useMe()!;
  const [navFlyoutOpen, setNavFlyoutOpen] = React.useState(false);
  const [userFlyoutOpen, setUserFlyoutOpen] = React.useState(false);

  const NavLinks = props.navItems.map(({ to: path, children: label }) => (
    <Route exact path={path} key={path}>
      {({ match }) => (
        <StyledNavLink
          to={path}
          onClick={() => {
            window.scroll(0, 0);
            setNavFlyoutOpen(false);
          }}
        >
          {label}
        </StyledNavLink>
      )}
    </Route>
  ));

  function toggleUserFlyout() {
    setUserFlyoutOpen(open => !open);
  }

  function toggleMobileNavigation() {
    setNavFlyoutOpen(open => !open);
  }

  return (
    <Grid>
      <Header
        toggleMobileNavigation={toggleMobileNavigation}
        toggleUserFlyout={toggleUserFlyout}
        navLinks={NavLinks}
        navFlyoutOpen={navFlyoutOpen}
      />

      <Flyout
        toggleUserFlyout={toggleUserFlyout}
        toggleMobileNavigation={toggleMobileNavigation}
        navFlyoutOpen={navFlyoutOpen}
        userFlyoutOpen={userFlyoutOpen}
        navLinks={NavLinks}
      />
      {props.banner}
      <Main>
        <TermsAndConditions>{props.content}</TermsAndConditions>
      </Main>
      <Footer />
    </Grid>
  );
}

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const StyledNavLink = styled(NavLink).attrs({
  activeStyle: {
    color: tokens.white,
  },
})`
  color: ${tokens.gray60};
  font-weight: 600;
`;

const Main = styled.main`
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;

  @media (max-width: ${tokens.screenXsMax}) {
    padding: ${tokens.spacer32} ${tokens.spacer24} 0;
  }
`;
